/**
 * Configuration needed in fetching a list of content from the Aggregate API. Environment specific content
 * variables are located in the config-api yaml files and can be found under Client.contentApi
 */

// default section value used when the path is not available or does not specify a specific section path segment (e.g. "/")
export const DEFAULT_SECTION = "homepage";

// Max story count
export const FEATURED_STORIES_MAX_COUNT = 9;
export const TOP_STORIES_MAX_COUNT = 1;
export const HIGHLIGHTED_STORIES_MAX_COUNT = 3;
export const CAROUSEL_STORIES_MAX_COUNT = 15;
export const MORE_CBC_STORIES_MAX_COUNT = 10;

export const DEFAULT_PAGE_SIZE = 25;

// After clicking "Load More", determine the index at which an Ad is inserted into the content list
// Index in content list to insert ad at (from another const file, edit this later)
export const AD_INDEX_LOAD_MORE = 2;

export const SUBJECTS_SET = {
    "news/covid-19/fact-check": "covid-19-fact-check",
    "news/covid-19/economy-and-finance": "covid-19-economy",
    "news/covid-19/stories-of-hope": "covid-19-good-news",
    "news/covid-19/lives-remembered": "covid-19-lives-remembered",
    "news/covid-19/international-news": "covid-19-international-news",
};

/**
 * Agg and GQL can find content by tags, with complex expressions and
 * optional tag types, for example: tags="(john^location:Ottawa)" for content
 * having a tag named “john” of any type AND a tag named “Ottawa” with the
 * type “location”. Other example: tags="collections:covid^(news|location:canada|foo)"
 * for content having a tag named “covid” with the type “collections” AND one the
 * given tags (news, canada, foo).
 * More info can be found here: https://docs.google.com/document/d/1qScTofot67d9lwdf-UcVaMzTMJOby-UcmPMQ7KH6mlM/edit#
 */
export const CONTENTLIST_TAGS = {
    "arts/beingblackincanada": "collections:Being Black in Canada",
    "books/beingblackincanada": "collections:Being Black in Canada",
    "news/marketplace": "generic:CBC Marketplace",
    "news/fifthestate": "generic:the fifth estate",
};

/**
 * When Agg (/v1/items?categorySlug=), or GQL (allContentItems(categorySlug:) need the
 * categorySlug value overriden. You can can also define an "empty" string.
 * e.g. news/canada/beingblackincanada/al: "empty"
 * When the section path matches a value in categorySlugOverride, it will use the value
 * as a lookup on categorySlugs.
 * e.g.
 * `arts/beingblackincanada: arts/watch` results in `categorySlug=arts-watch`
 * `sports/beingblackincanada: topstories` results in `categorySlug=empty-category`
 * schema: {section path}: {categorySlugs section path | "empty"}
 */
export const CONTENTLIST_CATEGORY_SLUG_OVERRIDE = {
    "dev/empty": "empty",
};
